import { render } from "./PostlistView.vue?vue&type=template&id=4efb2f3c&scoped=true"
import script from "./PostlistView.vue?vue&type=script&lang=js"
export * from "./PostlistView.vue?vue&type=script&lang=js"

import "./PostlistView.vue?vue&type=style&index=0&id=4efb2f3c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4efb2f3c"]])

export default __exports__